<script>
import constant from "@/configs/constant";

export default {
  name: "work_reservation_information",
  props: {
    workReservation: {
      type: Object,
      default: () => {}
    },
    wasteOrServicesByWorkReservation: {
      type: Array,
      default: () => []
    },
    disableComment: {
      type: Boolean,
      default: false
    },
    displayUserCreated: {
      type: Boolean,
      default: false,
    },
    displayTimeReservationDate: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {};
  },
  methods: {
    // updateWorkReservationRequest(id) {
    //   alert(this.workReservation.work_order_update_requests + id);
    // },
    regularly_date_formatted(date) {
      const dateFormatted = this.$options.filters.longDateWithJP(date);
      const dayOfWeek = this.$options.filters.longDate(date, 'day');

      return `${dateFormatted}（${dayOfWeek}）`
    },
    getUserCreated(user) {
      return user ? user.user_name : "";
    },
    getDayOfTimeZone(reservationDate) {
      return reservationDate
        ? reservationDate[0].zz_day_of_time_zone.day_of_time_zone
        : "";
    },
    getVendorSiteOfTreatmentName(disposalSite) {
      return disposalSite
        ? disposalSite.disposal_site_by_waste_category?.vendor_site_of_treatment?.name_abbreviated
        : "";
    },
    getVendorSiteOfTreatmentAddress(disposalSite) {
      return [
        this.$helpers.formatZipCode(disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.zip),
        disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_1,
        disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_2,
        disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_3,
        disposalSite?.disposal_site_by_waste_category?.vendor_site_of_treatment?.address_4,
      ].filter(x => !!x).join('')
    },
    getVendorSiteOfTreatmentTel(disposalSite) {
      return disposalSite
        ? disposalSite.disposal_site_by_waste_category?.vendor_site_of_treatment?.tel
        : "";
    },
  },
  computed: {
    zz_regularly_reservation_intervals() {
      return (
        this.$store.getters["options/options_tables"]
          .zz_regularly_reservation_intervals ?? []
      );
    },
    days_of_the_week() {
      return constant.DAY_OF_WEEKS;
    },
  },
};
</script>

<template>
  <b-card>
    <div class="mb-3 title-detail">■予約内容</div>
    <div class="mb-1 d-flex flex-wrap col-gap-5">
      <div>
        <span class="lbl-custom">予約番号：</span>
        <span>{{ workReservation.id }}</span>
      </div>
      <div>
        <span class="lbl-custom">依頼日：</span>
        <span>{{ workReservation.created_at | longDateWithJP }}（火）</span>
      </div>
      <div>
        <span class="lbl-custom">依頼者：</span>
        <span>{{ getUserCreated(workReservation.user_created) }}</span>
      </div>
    </div>
    <div class="mb-1 d-flex flex-wrap col-gap-5">
      <div>
        <span class="lbl-custom">定期予約</span>
      </div>
      <div class="d-flex flex-column">
        <div class="mb-1">
          <span class="lbl-custom">開始年月日：</span>
          <span>{{regularly_date_formatted(workReservation.regularly_reservation_start_date)}}</span>
          <span>～</span>
          <span class="lbl-custom ms-2">終了年月日：</span>
          <span>{{regularly_date_formatted(workReservation.regularly_reservation_end_date)}}</span>
        </div>
        <div>
          <span class="lbl-custom">時間帯：</span>
          <span class="ms-2">{{
            getDayOfTimeZone(workReservation.reservation_dates_by_work_reservation)
          }}</span>
          <div class="mt-1">
            <b-form-radio-group
              v-if="workReservation.zz_regularly_reservation_interval"
              v-model="workReservation.zz_regularly_reservation_interval.id"
              disabled
              class="d-inline-flex"
            >
              <b-form-radio
                v-for="item in zz_regularly_reservation_intervals"
                :key="item.id"
                :value="item.id"
                class="me-4"
              >
                {{ item.regularly_reservation_interval }}
                <span
                  v-if="
                    workReservation.regularly_reservation_date_of_month &&
                      item.regularly_reservation_interval == '毎月'
                  "
                  class="ms-1"
                >
                  {{ workReservation.regularly_reservation_date_of_month }}日
                </span>
              </b-form-radio>
            </b-form-radio-group>
            <b-form-radio-group v-else disabled class="d-inline-flex">
              <b-form-radio
                v-for="item in zz_regularly_reservation_intervals"
                :key="item.id"
                :value="item.id"
                class="me-4"
              >
                {{ item.regularly_reservation_interval }}
              </b-form-radio>
            </b-form-radio-group>
          </div>
          <div class="mt-1">
            <b-form-checkbox-group
              disabled
              v-if="workReservation.regularly_reservation_day_of_week"
              v-model="workReservation.regularly_reservation_day_of_week"
              :options="days_of_the_week"
              class="d-inline-flex gap-4"
            >
            </b-form-checkbox-group>
            <b-form-checkbox-group
              disabled
              v-else
              :options="days_of_the_week"
              class="d-inline-flex gap-4"
            >
            </b-form-checkbox-group>
          </div>
          <div class="mt-1 d-flex">
            <div>
              <span class="lbl-custom">車両：</span>
            </div>
            <div class="ms-2">
              <div
                v-if="workReservation.car_estimates_by_work_reservation"
                v-for="item in workReservation.car_estimates_by_work_reservation"
                :key="item.id"
              >
                {{ item.estimate.invoice_product_name }}×{{ item.pivot.number_of_cars }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-1">
      <div class="d-flex flex-wrap col-gap-5">
        <div class="mb-1" v-for="item in wasteOrServicesByWorkReservation">
          <div class="d-flex flex-wrap align-items-start">
            <div class="mr-3">
              <span class="lbl-custom">運搬先</span>
            </div>
            <div>
              {{
                getVendorSiteOfTreatmentName(item.waste_or_service_by_work_order.disposal_site)
              }}
            </div>
          <div class="ml-5">
            <span class="lbl-custom">住所：</span>
              {{
                getVendorSiteOfTreatmentAddress(item.waste_or_service_by_work_order.disposal_site)
              }}
          </div>
          <div class="ml-5">
            <span class="lbl-custom">電話番号：</span>
              {{
                getVendorSiteOfTreatmentTel(item.waste_or_service_by_work_order.disposal_site)
              }}
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="mb-1">
      <span class="lbl-custom">備考（要望入力欄）：</span>
      <span v-html="workReservation.remarks"></span>
    </div>
    <div class="mb1 d-flex gap-2 flex-wrap" v-if="displayUserCreated">
      <label class="lbl-custom ">変更依頼者：</label>
      {{workReservation.user_updated ? workReservation.user_updated.user_name : ''}}
    </div>
  </b-card>
</template>

<style scoped>
.lbl-custom {
  font-weight: 600;
}

.title-detail {
  font-size: 16px;
  font-weight: 600;
}
.col-gap-5 {
  column-gap: 5rem !important;
}
</style>
